import React, { useState } from "react";
import {
  CREATE_REFERENCE_LIBRARY_ELEMENT,
  NEW_COMPLETE_ELEMENT,
  NEW_DELETE_ELEMENT,
  NEW_UPDATE_ELEMENT,
} from "../routes/mutations";

import {
  ModalHeader,
  ModalContent,
  ModalActions,
  Button,
  Modal,
  ButtonGroup,
  Container,
} from "semantic-ui-react";
import { getEventMetadata, getSession, useMutationWrapper } from "../helper";
import { getNewWaitingForFormFields } from "../waitingfor/waiting_for_form";
import { SettingsCache } from "../cache/SettingsCache";
import { getProjectFormFields } from "../projects/project_form";
import { getNewNextActionFormFields } from "../nextaction/next_action_form";
import { getSomedayMaybeFormFields } from "../somedaymaybe/someday_maybe_form";
import {
  ButtonComponent,
  ButtonComponentProps,
  ButtonLabelComponentProps,
} from "../components/button/ButtonComponent";
import { NewNewModalWithFormComponent } from "../components/new_modal/NewNewModalWithFormComponent";
import { NewNewFormComponentProps } from "../components/new_form/NewNewFormComponent";
import { getReferenceLibraryForm } from "../referencelibrary/reference_library_form";

export type InputElementType = {
  id: number;
  name: string;
};

enum STATE {
  TRUE,
  FALSE,
  UNDEFINED,
}

export const ProcessInputModal = (props: {
  input: InputElementType;
  deleteCallback: (id: number) => void;
}) => {
  const [open, setOpen] = React.useState(false);
  const [isActionable, setIsActionable] = useState(STATE.UNDEFINED);
  const [isMultiStep, setIsMultiStep] = useState(STATE.UNDEFINED);
  const [bestToHandle, setBestToHandle] = useState(STATE.UNDEFINED);
  const [canDoRightNow, setCanDoRightNow] = useState(STATE.UNDEFINED);

  const deleteCompleted = () => {
    props.deleteCallback(props.input.id);
    setOpen(false);
  };

  const [deleteInputElementMutation] = useMutationWrapper(
    NEW_DELETE_ELEMENT.documentNode,
    (data) => deleteCompleted(),
  );

  const [completeElementMutation] = useMutationWrapper(
    NEW_COMPLETE_ELEMENT.documentNode,
    (data) => deleteCompleted(),
  );
  return (
    <Modal
      onClose={() => setOpen(false)}
      onOpen={() => setOpen(true)}
      open={open}
      trigger={
        <Button primary floated="right" className="process-item-button">
          Process Input Element
        </Button>
      }
    >
      <ModalHeader>Process Input: {props.input.name}</ModalHeader>
      <ModalContent>
        <Container textAlign="center">Is this actionable?</Container>
        <div>
          <ButtonGroup fluid>
            <Button
              onClick={() => setIsActionable(STATE.TRUE)}
              id="is-actionable-yes"
              positive={isActionable === STATE.TRUE}
            >
              Yes
            </Button>
            <Button
              positive={isActionable === STATE.FALSE}
              onClick={() => setIsActionable(STATE.FALSE)}
              id="is-actionable-no"
            >
              No
            </Button>
          </ButtonGroup>
          <br></br>
          <br />
          <div
            style={{ display: isActionable === STATE.FALSE ? "block" : "none" }}
          >
            <Container textAlign="center">
              <Button
                onClick={() => {
                  deleteInputElementMutation({
                    variables: {
                      id: props.input.id,
                      session: getSession(),
                      eventMetadata: getEventMetadata(),
                      isChildElement: true,
                    },
                  });
                }}
                id="eliminate-button"
                primary
              >
                Delete
              </Button>
              <NewNewModalWithFormComponent
                props={{
                  header: "Create Someday/Maybe",
                  triggerProps: {
                    label: "Create Someday/Maybe",
                    type: "button",
                  },
                  formComponentProps: new NewNewFormComponentProps({
                    form: {
                      formFields: getSomedayMaybeFormFields(),
                      type: "single_form",
                    },
                    startingData: {
                      id: props.input.id,
                      name: props.input.name,
                      lifeDomainId: undefined,
                      parentElementId: undefined,
                    },
                  }),
                  apiCall: NEW_UPDATE_ELEMENT,
                  callback: deleteCompleted,
                }}
              />
              <NewNewModalWithFormComponent
                props={{
                  header: "Create Reference Library Item",
                  triggerProps: {
                    label: "Create Reference Library Item",
                    type: "button",
                  },
                  formComponentProps: new NewNewFormComponentProps({
                    form: getReferenceLibraryForm(),
                    startingData: {
                      inputElementId: props.input.id,
                      name: props.input.name,
                      type: 1,
                      elementIds: [],
                    },
                  }),
                  apiCall: {
                    documentNode: CREATE_REFERENCE_LIBRARY_ELEMENT,
                    key: "createReferenceLibraryElement",
                  },
                  callback: deleteCompleted,
                }}
              />
            </Container>
          </div>
          <div
            style={{ display: isActionable === STATE.TRUE ? "block" : "none" }}
          >
            <Container textAlign="center">
              Does this require multiple steps to resolve?
            </Container>
            <ButtonGroup fluid>
              <Button
                positive={isMultiStep === STATE.TRUE}
                onClick={() => setIsMultiStep(STATE.TRUE)}
                id="is-multi-step-yes"
              >
                Yes
              </Button>
              <Button
                positive={isMultiStep === STATE.FALSE}
                onClick={() => setIsMultiStep(STATE.FALSE)}
                id="is-multi-step-no"
              >
                No
              </Button>
            </ButtonGroup>
            <br></br>
            <br />
            <div
              style={{
                display: isMultiStep === STATE.TRUE ? "block" : "none",
              }}
            >
              <Container textAlign="center">
                <NewNewModalWithFormComponent
                  props={{
                    header: "Create Project",
                    formComponentProps: new NewNewFormComponentProps({
                      form: {
                        formFields: getProjectFormFields(),
                        type: "single_form",
                      },
                      startingData: {
                        id: props.input.id,
                        name: props.input.name,
                        lifeDomainId: undefined,
                        parentElementId: undefined,
                      },
                    }),
                    triggerProps: {
                      label: "Create Project",
                      type: "button",
                    },
                    apiCall: NEW_UPDATE_ELEMENT,
                    callback: deleteCompleted,
                  }}
                />
              </Container>
            </div>
            {isMultiStep === STATE.FALSE && (
              <div>
                <Container textAlign="center">
                  Are you the best person to handle this?
                </Container>
                <ButtonGroup fluid>
                  <Button
                    positive={bestToHandle === STATE.TRUE}
                    onClick={() => setBestToHandle(STATE.TRUE)}
                    id="best-to-handle-yes"
                  >
                    Yes
                  </Button>
                  <Button
                    positive={bestToHandle === STATE.FALSE}
                    onClick={() => setBestToHandle(STATE.FALSE)}
                    id="best-to-handle-no"
                  >
                    No
                  </Button>
                </ButtonGroup>
                <br></br>
                <br />
                {bestToHandle === STATE.TRUE && (
                  <div>
                    <Container textAlign="center">
                      Does it take two minutes to do, and can you do it right
                      now?
                    </Container>
                    <ButtonGroup fluid>
                      <Button
                        positive={canDoRightNow === STATE.TRUE}
                        onClick={() => setCanDoRightNow(STATE.TRUE)}
                        id="do-now-yes"
                      >
                        Yes
                      </Button>
                      <Button
                        positive={canDoRightNow === STATE.FALSE}
                        onClick={() => setCanDoRightNow(STATE.FALSE)}
                        id="do-now-no"
                      >
                        No
                      </Button>
                    </ButtonGroup>
                    <br></br>
                    <br />
                    {canDoRightNow === STATE.TRUE && (
                      <Container textAlign="center">
                        <Button
                          primary
                          onClick={() =>
                            completeElementMutation({
                              variables: {
                                id: props.input.id,
                                session: getSession(),
                                eventMetadata: getEventMetadata(),
                                isChildElement: true,
                              },
                            })
                          }
                          id="do-now-button"
                        >
                          Do Right Now
                        </Button>
                      </Container>
                    )}
                    {canDoRightNow === STATE.FALSE && (
                      <Container textAlign="center">
                        <NewNewModalWithFormComponent
                          props={{
                            header: "Create Next Action",
                            formComponentProps: new NewNewFormComponentProps({
                              form: {
                                formFields: getNewNextActionFormFields(),
                                type: "single_form",
                              },
                              startingData: {
                                id: props.input.id,
                                name: props.input.name,
                                priority:
                                  SettingsCache.getInstance().getDefaultPriority(),
                              },
                            }),
                            triggerProps: {
                              label: "Create Next Action",
                              type: "button",
                            },
                            apiCall: NEW_UPDATE_ELEMENT,
                            callback: deleteCompleted,
                          }}
                        />
                      </Container>
                    )}
                  </div>
                )}
                {bestToHandle === STATE.FALSE && (
                  <div>
                    <Container textAlign="center">
                      <NewNewModalWithFormComponent
                        props={{
                          header: "Create Waiting For",
                          triggerProps: {
                            type: "button",
                            label: "Create Waiting For",
                          },
                          formComponentProps: new NewNewFormComponentProps({
                            form: {
                              formFields: getNewWaitingForFormFields(),
                              type: "single_form",
                            },
                            startingData: {
                              id: props.input.id,
                              name: props.input.name,
                            },
                          }),
                          apiCall: NEW_UPDATE_ELEMENT,
                          callback: deleteCompleted,
                        }}
                      />
                    </Container>
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      </ModalContent>
      <ModalActions>
        <ButtonComponent
          props={
            new ButtonComponentProps({
              label: new ButtonLabelComponentProps({ text: "Close" }),
              primary: false,
              onClickFunction: () => setOpen(false),
              disabled: false,
              page: "ProcessInTrayElementModal",
            })
          }
        />
      </ModalActions>
    </Modal>
  );
};
